import {TaskInputGroup} from "./TaskInputGroup";
import {AirflowWorkerQueue, ChronoUnitStr} from "../enums";
import {DatasetIdentifierStr} from "../dataset/DatasetIdentifierStr";
import {ProductTemplateTaskSelectionOptions} from "../product-template/ProductTemplateTaskSelectionOptions";
import {TaskTemplateInfo} from "./task-template/TaskTemplateInfo";

export class ScheduledTaskDTO {
    id?: string;
    parentId?: string;
    companyId?: number;
    companyRef?: string;

    title: string = "";
    description: string | null = "";

    useCategories: boolean = false;

    environmentId: string = "default_legacy";
    executorQueue: AirflowWorkerQueue = "DEFAULT";
    queueSlots: number = 1;
    timeout: number = 300;
    isSkipped: boolean = false;

    downstreamTasks: string[] = [];
    upstreamTasks: string[] = [];

    constants: Record<string, string> = {};
    productTemplates: Record<number, ProductTemplateTaskSelectionOptions> = {};
    freestyleJson: string = "{\n\t\n}";

    indexedInputDatasets: DatasetIdentifierStr[] = [];
    indexedOutputDatasets: DatasetIdentifierStr[] = [];
    namedInputDatasets: Record<string, DatasetIdentifierStr> = {};
    namedOutputDatasets: Record<string, DatasetIdentifierStr> = {};

    inputCategories: Record<string, number> = {};
    outputCategories: Record<string, number> = {};

    categoryDataLag: number = 0;
    categoryDataLagUnit: ChronoUnitStr = "HOURS";
    categoryDataLead: number = 0;
    categoryDataLeadUnit: ChronoUnitStr = "HOURS";

    dataLag: number = 0;
    dataLagUnit: ChronoUnitStr = "HOURS";
    dataLead: number = 0;
    dataLeadUnit: ChronoUnitStr = "HOURS";
    calculationTimeOffset: number = 0;
    calculationTimeOffsetUnit: ChronoUnitStr = "HOURS";
    calculationPeriod: number = 1;
    calculationPeriodUnit: ChronoUnitStr = "HOURS";
    calculationSteps: number = 1;

    extraExecutionRecipients: string[] = [];
    overrideRecipients: boolean = false;

    codeFileName: string | null = null;
    codeFileId: number | null = null;
    code?: string | null = null;
    codeB64?: string | null = null;

    templateInfo: TaskTemplateInfo = {};
    inputGroups: Record<string, TaskInputGroup[]> = {};

    constructor(data?: Partial<ScheduledTaskDTO>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}